"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportEventTypeOut = void 0;
class ExportEventTypeOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ExportEventTypeOut.attributeTypeMap;
    }
}
exports.ExportEventTypeOut = ExportEventTypeOut;
ExportEventTypeOut.discriminator = undefined;
ExportEventTypeOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=ExportEventTypeOut.js.map